import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import accountService from "../../services/AccountService.js";

import Button from "../Nano/Buttons/Button.js";
import Type from "../Global/Typography.js";
import Modal from "../Global/Modal.js";

const multiple = nota.global.multiple;

const StyledCookiesModal = styled.div`
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  width: 400px;
  height: auto;
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }

  .textContianer {
    padding-top: ${multiple * 3 + "px"};
    text-align: justify;
  }

  .buttonsWrapper {
    margin-top: ${multiple * 3 + "px"};
    .buttonWrapper {
      width: 100%;
      text-align: center;
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
  }
`;

class CookiesModal extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onCookiesModalLanguageChange, false);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onCookiesModalLanguageChange = () => {
    this.forceUpdate();
  };

  acceptCookies = () => {
    localStorage.setItem("cookies-accept", true);
    this.forceUpdate();
  };

  render() {
    return (
      <Modal
        show={accountService.getToken() !== null && (localStorage.getItem("cookies-accept") ?? "false") === "false"}
        content={
          <StyledCookiesModal>
            <NanoFlex className="headerModal" justifyContent="flex-start">
              <Type.h2>
                About Cookies on <b>NOTA</b>
              </Type.h2>
            </NanoFlex>

            <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
              <NanoFlex className="modalWrapper" flexDirection={"column"}>
                <NanoFlex className="textContianer" flexDirection={"column"}>
                  {this.translation.geral.cookies.map((p) => {
                    return <Type.p key={p}>{p}</Type.p>;
                  })}
                </NanoFlex>

                <NanoFlex className="buttonsWrapper" flexDirection="column">
                  <Button label={this.translation.geral.cookiesAccept} type={"button"} clickAction={this.acceptCookies} />
                  <a className="footer-link" href="https://www.mediametrie.fr/en/personal-data-mediametrie" rel="noopener noreferrer" target="_blank">
                    <Button label={this.translation.geral.privacyPolicy} type={"button"} simple />
                  </a>
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </StyledCookiesModal>
        }
      />
    );
  }
}

export default CookiesModal;

/*
    Doc
    import CookiesModal from '../../Micro/CookiesModal.js';

    <CookiesModal />
*/
